<script>
  import { getExtention } from '@client/utils/files';

  export let row = {};

  const colors = {
    jpg: 'var(--color-blue-300)',
    jpeg: 'var(--color-blue-300)',
    gif: 'var(--color-green-300)',
    png: 'var(--color-red-300)',
    pdf: 'var(--color-red-300)'
  };

  $: type = getExtention(row.filename);
</script>

<div class="asset-type" style="background-color: {colors[type]};">
  {type}
</div>

<style lang="scss">
  .asset-type {
    background-color: var(--color-red-300);
    border-radius: var(--border-radius-base);
    color: var(--color-white);
    display: inline-flex;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
  }
</style>
